import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { useInView } from "../../hooks/useInView";

function FaqItem({ question, answer, delay = 0 }) {
  const [open, setOpen] = useState(false);
  const [ref, inView] = useInView(0.1);
  return (
    <div ref={ref} style={{ opacity: inView ? 1 : 0, transform: inView ? "translateY(0)" : "translateY(24px)", transition: `opacity 0.5s ease ${delay}ms, transform 0.5s ease ${delay}ms` }}
      className="border border-gray-200 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-shadow">
      <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-4 text-left bg-white hover:bg-gray-50 transition-colors">
        <span className="font-semibold text-gray-900 text-sm pr-3">{question}</span>
        <span className={`flex-shrink-0 w-7 h-7 rounded-full bg-blue-900 flex items-center justify-center transition-transform duration-300 ${open ? "rotate-180" : ""}`}>
          <ChevronDown className="w-3.5 h-3.5 text-white" />
        </span>
      </button>
      <div style={{ maxHeight: open ? "300px" : "0", overflow: "hidden", transition: "max-height 0.4s cubic-bezier(0.22,1,0.36,1)" }}>
        <p className="px-4 pb-4 text-gray-600 text-sm leading-relaxed">{answer}</p>
      </div>
    </div>
  );
}


export { FaqItem };
